import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const UsersComponent = lazy(async () => await import("@/pages/dashboard/control/users"))

export const controlUsersRoutes: CustomRoute = {
  path: "users",
  handle: { label: "Пользователи", i18Key: "users" },
  Component: UsersComponent
}
